import React, {Component} from 'react';
import {Table, Modal, Button} from 'antd';
import {deDownloadTask, getDownloadTask} from "../actions";
import Card from "antd/es/card";
import {applicationName, formatDate} from "../utils";
import {converFileSize} from "../utils";

/**
 * 文件下载任务列表
 */
class DownLoadTaskList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
        };

        this.columns = [
            {
                title: '文件名称',
                dataIndex: 'fileName',
                width: '200',
                align: 'center',
                editable: false,
            },
            {
                title: '文件大小',
                dataIndex: 'fileSize',
                editable: false,
                align: 'center',
                width: '100',
                render: (text, record) => {
                    return converFileSize(record.fileSize)
                }
            },
            {
                title: '状态',
                dataIndex: 'stateName',
                width: '100',
                align: 'center',
            },
            {
                title: '过期时间',
                dataIndex: 'overDate',
                width: '100',
                align: 'center',
            },
            {
                title: '添加时间',
                dataIndex: 'submitDate',
                width: '20%',
                align: 'center',
                render: (text, record) => {
                    return formatDate(record.createDate.time)
                }
            },
            {
                title: '操作',
                dataIndex: 'operate',
                align: 'center',
                width: '100',
                render: (text, record) => {
                    if (record.filePath) {
                        return <div><a onClick={() => {
                            this.deleteDownLoadTask(record.id)
                        }}>删除</a> <a
                            href={"/cm-sites-" + applicationName() + "/storage/downloadZip/" + record.id}>下载</a>
                        </div>
                    } else {
                        return <div><a onClick={() => {
                            this.deleteDownLoadTask(record.id)
                        }}>删除</a></div>
                    }
                }
            }
        ];
        this.calldeDownloadTask = this.calldeDownloadTask.bind(this);
    }

    /**
     * 更具任务id,删除任务
     * @param id
     */
    deleteDownLoadTask(id) {
        let that = this;
        Modal.confirm({
            title: '删除确认',
            content: '删除后再次下载需要重新压缩\n' +
                '\n' +
                '请问是否删除',
            okText: '确认',
            cancelText: '取消',
            onCancel() {
            },
            onOk() {
                deDownloadTask(id, that.calldeDownloadTask)
            },
        });
    }

    calldeDownloadTask(data) {
        if (data) {
            this.refreshPage();
        }
    }

    componentDidMount() {
        getDownloadTask({}, this.callgetDownloadTask.bind(this))
    }

    refreshPage() {
        getDownloadTask({}, this.callgetDownloadTask.bind(this))
    }

    callgetDownloadTask(data) {
        if (data) {
            this.setState({
                data: data
            })
        }

    }

    render() {
        return <div style={{margin: '15px 0px 15px 15px',height:'calc(100vh - 100px)'}}>
                <div style={{height:'42px',backgroundColor:'#fff'}}>
                    <div style={{float: "left",padding:'3px'}}>我的下载
                        <div style={{color: 'red'}}>以下文件为临时文件 仅保留7天，请尽快下载！</div>
                    </div>
                    <div style={{float:'right',marginRight:'30px',marginTop:'5px'}}><Button icon="reload" onClick={() => this.refreshPage()}>
                        刷新</Button></div>
                </div>
                <Card style={{height: 'calc(100vh - 142px)'}}>
                <Table
                    dataSource={this.state.data}
                    columns={this.columns}
                />
                </Card>
        </div>
    }
}

export default DownLoadTaskList;